import TagsContainer from './TagsContainer.component';

export default TagsContainer;
